/* eslint-disable no-plusplus */
import Papa from 'papaparse';
// eslint-disable-next-line no-unused-vars
import i18next from 'i18next';
import 'regenerator-runtime/runtime';
import { mediaAssets, shuffle } from '../helperFunctions';

// eslint-disable-next-line import/no-mutable-exports, prefer-const
export let corpora = {};
function transformCSV(csvInput) {
  return csvInput.reduce((accum, row) => {
    const newRow = {
      word1: row.Word1,
      word2: row.Word2,
      img1: mediaAssets.images[row.Word1],
      img2: mediaAssets.images[row.Word2],
      wordPairing: row.wordPairing,
      distractorId: row.distractorId,
      itemGroup: row.itemGroup,
      source: row.source,
      correct_side: Math.round(Math.random()),
    };
    accum.push(newRow);
    return accum;
  }, []);
}

function transformCSV4test(d) {
  const itemList = transformCSV(d);
  const arr = [];
  let j = 0;
  let word = '';
  for (let i = 0; i < itemList.length; i++) {
    if (word === itemList[i].word1) {
      arr[j - 1].push(itemList[i]);
    } else {
      word = itemList[i].word1;
      arr.push([itemList[i]]);
      j += 1;
    }
  }
  return arr;
}

export async function loadCorpus(allCorpus) {
  // eslint-disable-next-line no-unused-vars
  function downloadCSV(url, key) {
    return new Promise((resolve, reject) => {
      Papa.parse(url, {
        download: true,
        header: true,
        skipEmptyLines: true,
        complete: function (results) {
          const stimuli = results.data;
          corpora.test_previous = shuffle(
            transformCSV4test(stimuli.filter((row) => row.itemGroup === 'test' && row.source !== 'dutch')),
          );
          corpora.test_new = shuffle(
            transformCSV4test(stimuli.filter((row) => row.itemGroup === 'test' && row.source === 'dutch')),
          );
          corpora.practice = shuffle(transformCSV4test(stimuli.filter((row) => row.itemGroup === 'practice')));
          corpora.catch = shuffle(transformCSV4test(stimuli.filter((row) => row.itemGroup === 'catch')));

          resolve(results.data);
        },
        error: function (error) {
          reject(error);
        },
      });
    });
  }

  async function parseMultipleCSVs(urls) {
    const promises = Object.entries(urls).map(([key, url]) => downloadCSV(url, key));
    return Promise.all(promises);
  }

  async function fetchData() {
    const urls = {
      all: `https://storage.googleapis.com/roar-vocab/CSV/${allCorpus}.csv`,
    };

    try {
      await parseMultipleCSVs(urls);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error:', error);
    }
  }

  await fetchData();
}

// const practiceCorpus = 'vocab-new-practice';
// const stimulusCorpus = 'vocab-new-test';
// const catchCorpus = 'vocab-new-catch';

// await loadCorpus(practiceCorpus, stimulusCorpus, catchCorpus);
